// Font
import "typeface-karla";

// Global styles
import "./src/styles/normalize.css";
import "./src/styles/layout.scss";

// Kill stale service workers from older deployments/setups.
export const onClientEntry = () => {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  navigator.serviceWorker
    .getRegistrations()
    .then(registrations => {
      registrations.forEach(registration => {
        registration.unregister();
      });
    })
    .catch(() => {});
};
